<template>
    <div class="orderAudio">
        <div class="blueInfo">
            * 以下为该订单归属行程的全部行程录音，若为拼车订单可能包含该行程下的其他拼友的订单录音信息
        </div>
        <div v-if="audioList && audioList.length">
            <div class="flex-between" style="margin: 10px 0;">
                <span>正在播放第{{ currentAudioIndex + 1 }}段，共{{ audioList.length }}段，该段录制于{{
                    audioList[currentAudioIndex].startTime | filterTime }}至{{ audioList[currentAudioIndex].endTime |
                    filterTime }}</span>
                <el-button type="primary" @click="downloadAudio" :loading="loading">录音下载</el-button>
            </div>
            <div class="flex" style="margin-top: 16px;">
                <el-button size="large" icon="el-icon-arrow-left" :disabled="currentAudioIndex === 0"
                    @click="playPrevAudio" circle></el-button>
                <audio ref="singleAudio" controlslist="noplaybackrate nodownload" style="width: 100%;margin: 0 16px;" controls
                    :src="audioList[currentAudioIndex].recordUrl" @play="onPlay(currentAudioIndex)"
                    @ended="onAudioEnded"></audio>
                <el-button size="small" icon="el-icon-arrow-right"
                    :disabled="currentAudioIndex === audioList.length - 1" @click="playNextAudio" circle></el-button>
            </div>
        </div>
        <div v-else class="flex-center">
            <el-empty description="暂无录音"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: "orderAudio",
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            loading: false,
            audioList: [],
            /**
             * 当前正在播放的录音索引
             * @type {number}
             */
            currentAudioIndex: 0,
        };
    },
    watch: {
        rowData: {
            handler(val) {
                if (!val.id) return

                this.getAudioFn()
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        async getAudioFn() {
            const url = '/api/v1/manage/sound/record/' + this.rowData.orderDriverId
            const { data, code } = await this.$axios.get(url)
            if (code === 1 && data) {
                this.audioList = data.map((item) => {
                    return {
                        ...item,
                        recordUrl: window.configure.qiniuUrl + item.recordUrl
                    }
                })
            }
        },
        getTimes(file) {
            var content = file;
            var url = URL.createObjectURL(content);
            //经测试，发现audio也可获取视频的时长
            var audioElement = new Audio(url);
            audioElement.addEventListener("loadedmetadata", (_event) => {
                this.audioDuration = parseInt(audioElement.duration);
                // console.log(this.audioDuration);
            });
        },
        //时间格式化，将获取到的时长转为分钟+秒
        changeTimes(seconds) {
            var minutes = Math.floor(seconds / 60);
            var remainingSeconds = seconds % 60;
            return minutes + ":" + (remainingSeconds < 10 ? "0" : "") + remainingSeconds;
        },
        /**
         * 播放音频时的处理，自动播放当前音频
         * @param {number} index 当前播放的音频索引
         */
        onPlay(index) {
            /** @type {HTMLAudioElement} */
            const audioDom = this.$refs.singleAudio instanceof Array
                ? this.$refs.singleAudio[0]
                : this.$refs.singleAudio;
            if (audioDom) {
                try { audioDom.play(); } catch (e) { }
                // 如需时长，建议监听 loadedmetadata 事件
                // audioDom.addEventListener('loadedmetadata', () => {
                //     console.log('duration:', audioDom.duration);
                // });
            }
        },
        async downloadAudio() {
            this.loading = true
            const url = '/api/v1/manage/sound/record/download/all'
            const data = await this.$axios.get(url, { orderDriverId: this.rowData.orderDriverId }, { responseType: 'blob' })
            const blob = new Blob([data], { type: "application/zip" })
            this.loading = false
            const fileName = `${this.rowData.driverPhone}_${this.$utils.timeFn(new Date().getTime(), 'YYYYMMDDHHmmSS')}.zip`;
            if ('download' in document.createElement('a')) { // 非IE下载
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = window.URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                window.URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
            } else { // IE10+下载
                navigator.msSaveBlob(blob, fileName)
            }
        },
        /**
         * 切换到上一段录音，并自动播放
         */
        playPrevAudio() {
            if (this.currentAudioIndex > 0) {
                this.currentAudioIndex--;
                this.$nextTick(() => {
                    /** @type {HTMLAudioElement} */
                    const audio = this.$refs.singleAudio[0];
                    if (audio) {
                        try { audio.play(); } catch (e) { /* 忽略自动播放异常 */ }
                    }
                });
            }
        },
        /**
         * 切换到下一段录音，并自动播放
         */
        playNextAudio() {
            if (this.currentAudioIndex < this.audioList.length - 1) {
                this.currentAudioIndex++;
                this.$nextTick(() => {
                    /** @type {HTMLAudioElement} */
                    const audio = this.$refs.singleAudio[0];
                    if (audio) {
                        try { audio.play(); } catch (e) { /* 忽略自动播放异常 */ }
                    }
                });
            }
        },
        /**
         * 录音播放结束事件处理，若不是最后一段则自动播放下一段
         */
        onAudioEnded() {
            if (this.currentAudioIndex < this.audioList.length - 1) {
                this.currentAudioIndex++;
                this.$nextTick(() => {
                    /** @type {HTMLAudioElement} */
                    const audio = this.$refs.singleAudio instanceof Array
                        ? this.$refs.singleAudio[0]
                        : this.$refs.singleAudio;
                    if (audio) {
                        try { audio.play(); } catch (e) { }
                    }
                });
            }
        },
    },
};
</script>
